// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".account-button__popover-toggle{align-items:center;display:flex;height:44px;justify-content:center;width:44px}.account-button__user-image-wrapper{height:30px;position:relative;width:30px}.account-button__user-image{height:100%;width:100%}.account-button__user-image-notification{background:var(--color-highlight);border:1px solid var(--color-lightest);border-radius:50%;height:9px;left:1px;position:absolute;top:1px;width:9px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
